var exports = {
  "Q": "x7f9a0e16--1fd120--content",
  "M": "x7f9a0e16--1fd120--contacts",
};

module.exports = exports;
